<template>
  <el-main>
    <div class="control-bar">
      <span class="title">用户管理</span>
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="filters.realname" placeholder="姓名" clearable @clear="getLists(1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.mobile" placeholder="手机号" clearable @clear="getLists(1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.gender" placeholder="性别" clearable @change="getLists(1)">
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.isvip" placeholder="VIP" clearable @change="getLists(1)">
            <el-option label="VIP会员" :value="1"></el-option>
            <el-option label="普通用户" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getLists(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table ref="lists" :data="lists" border header-cell-class-name="table-header" @sort-change="sortChange">
      <el-table-column label="UID" align="center" prop="uid" width="80"></el-table-column>
      <el-table-column label="昵称" prop="nickname"></el-table-column>
      <el-table-column label="姓名" prop="realname"></el-table-column>
      <el-table-column label="手机号" prop="mobile" width="120"></el-table-column>
      <el-table-column label="性别" align="center" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.gender == 1">男</span>
          <span v-else-if="scope.row.gender == 2">女</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="会员到期" prop="viptime" align="center" width="160" sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.row.isvip == 1 && scope.row.viptime">
            {{ scope.row.viptime | timeTodate("Y-m-d H:i:s") }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="红豆" align="center" prop="credits" width="80" sortable="custom"></el-table-column>
      <el-table-column label="在线" align="center" width="80" prop="isonline" sortable="custom">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isonline == 1" type="success" size="mini">在线</el-tag>
          <el-tag v-else type="info" size="mini">离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="登录时间" prop="lasttime" align="center" width="160" sortable="custom">
        <template slot-scope="scope">{{ scope.row.lasttime | timeTodate("Y-m-d H:i:s") }}</template>
      </el-table-column>
      <el-table-column label="注册时间" prop="dateline" align="center" width="160" sortable="custom">
        <template slot-scope="scope">{{scope.row.dateline | timeTodate("Y-m-d H:i:s")}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-view" circle size="small"
            @click="viewUser(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="sizes, prev, pager, next, total" :page-sizes="[10, 15, 20, 50, 100]"
      @size-change="handleSizeChange" @current-change="getLists" :current-page="page" :page-size="$store.state.offset" :total="totals">
    </el-pagination>

    <!-- 用户详情 -->
    <el-dialog title="用户详情" :visible.sync="dialogVisible" width="600px">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="UID">{{ detail.uid }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ detail.nickname }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{ detail.realname }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.mobile }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <span v-if="detail.gender == 1">男</span>
          <span v-else-if="detail.gender == 2">女</span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="生日">{{ detail.birthday || '-' }}</el-descriptions-item>
        <el-descriptions-item label="身高">{{ detail.height ? detail.height + ' cm' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="体重">{{ detail.weight ? detail.weight + ' kg' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="学历">{{ detail.education || '-' }}</el-descriptions-item>
        <el-descriptions-item label="毕业院校">{{ detail.university || '-' }}</el-descriptions-item>
        <el-descriptions-item label="薪资">{{ detail.salary || '-' }}</el-descriptions-item>
        <el-descriptions-item label="婚姻状况">{{ detail.marriage || '-' }}</el-descriptions-item>
        <el-descriptions-item label="房车">{{ detail.house || '-' }} / {{ detail.car || '-' }}</el-descriptions-item>
        <el-descriptions-item label="地区">{{ (detail.province || '') + (detail.city || '') + (detail.area || '') || '-' }}</el-descriptions-item>
        <el-descriptions-item label="VIP">
          <el-tag v-if="detail.isvip == 1" type="danger" size="mini">VIP</el-tag>
          <span v-else>普通用户</span>
        </el-descriptions-item>
        <el-descriptions-item label="VIP到期">
          {{ detail.viptime | timeTodate("Y-m-d H:i:s") }}
        </el-descriptions-item>
        <el-descriptions-item label="红豆余额">{{ detail.credits }}</el-descriptions-item>
        <el-descriptions-item label="魅力指数">{{ detail.charm || '-' }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">
          {{ detail.dateline | timeTodate("Y-m-d H:i:s") }}
        </el-descriptions-item>
        <el-descriptions-item label="最后登录">
          {{ detail.lasttime | timeTodate("Y-m-d H:i:s") }}
        </el-descriptions-item>
      </el-descriptions>
      <template slot="footer">
        <el-button @click="dialogVisible=false">关 闭</el-button>
      </template>
    </el-dialog>
  </el-main>
</template>

<script>
  import {
    httpRequest,
    getCookie
  } from '@/utils/app'
  export default {
    data() {
      return {
        admin: {},
        totals: 0,
        page: 1,
        lists: [],
        filters: {
          realname: '',
          mobile: '',
          gender: '',
          isvip: ''
        },
        ord: 'uid desc',
        detail: {},
        dialogVisible: false
      }
    },
    created() {
      this.admin = getCookie('admin')
      this.getLists(1)
    },
    methods: {
      // 每页条数变更：写入 Vuex + localStorage（全局共享）后重新加载
      handleSizeChange(e) {
        this.$store.commit('setOffset', e)
        this.getLists(1)
      },
      // 排序变更（服务端排序）：将 ascending/descending 转为 asc/desc 拼接为 MySQL ORDER BY 语法
      sortChange(e) {
        this.ord = ''
        if (e.order) {
          this.ord = e.prop + ' ' + e.order.replace('ending', '')
        } else {
          this.ord = 'uid desc'
        }
        this.getLists(1)
      },
      getLists(page) {
        let params = {
          action: 'user_lists',
          page: page,
          offset: this.$store.state.offset
        }
        if (this.ord) params.ord = this.ord
        if (this.filters.realname) params.realname = this.filters.realname
        if (this.filters.mobile) params.mobile = this.filters.mobile
        if (this.filters.gender !== '' && this.filters.gender !== null) params.gender = this.filters.gender
        if (this.filters.isvip !== '' && this.filters.isvip !== null) params.isvip = this.filters.isvip

        httpRequest(params).then(response => {
          if (response.error === false) {
            this.page = page
            this.lists = response.data
            this.totals = parseInt(response.totals)
          } else {
            this.$message({
              type: 'error',
              message: response.msg || '加载失败'
            })
          }
        })
      },
      viewUser(row) {
        this.detail = row
        this.dialogVisible = true
      }
    }
  }
</script>
